import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js', { scope: '/', updateViaCache: 'none' }).catch(() => {});
  });
}

// A dashboard tab left open keeps running the old build after a deploy.
// Offer a reload (never automatic, so a half-filled form is not lost).
const loadedBundle = (document.querySelector('script[src*="/static/js/main."]') || {}).src || '';
async function checkForNewBuild() {
  if (!loadedBundle || document.getElementById('new-build-bar')) return;
  try {
    const html = await (await fetch('/index.html', { cache: 'no-store' })).text();
    const live = (html.match(/\/static\/js\/main\.[a-z0-9]+\.js/) || [])[0];
    if (!live || loadedBundle.endsWith(live)) return;
    const bar = document.createElement('div');
    bar.id = 'new-build-bar';
    bar.style.cssText = 'position:fixed;left:50%;bottom:16px;transform:translateX(-50%);z-index:10000;'
      + 'background:#1a1a2e;color:#fff;padding:10px 16px;border-radius:10px;box-shadow:0 4px 16px rgba(0,0,0,.3);'
      + 'font:14px Inter,system-ui,sans-serif;display:flex;gap:12px;align-items:center';
    bar.textContent = 'A new version of the dashboard is available.';
    const btn = document.createElement('button');
    btn.textContent = 'Reload';
    btn.style.cssText = 'border:0;border-radius:8px;padding:6px 14px;font-weight:700;background:#f5c542;color:#1a1a2e;cursor:pointer';
    btn.onclick = () => window.location.reload();
    bar.appendChild(btn);
    document.body.appendChild(bar);
  } catch (e) { /* offline: keep the current build */ }
}
document.addEventListener('visibilitychange', () => { if (document.visibilityState === 'visible') checkForNewBuild(); });
setInterval(checkForNewBuild, 5 * 60 * 1000);
